import { forms } from "application/constants/app-constants";
import { filter, find, isNil, pathOr, split, startsWith, map, isEmpty } from "ramda";
import { getNavLocale } from ".";

export default function getStructureFieldInfo(structure, path, param) {
  const field = find(sf => sf.path === path, pathOr([], ["structureFields"], structure));

  switch(param) {
    case "label":
      return pathOr("", ["name"], field);
    case "options":
      return getOptions(field);
    default:
      return null;
  }
}

const getOptions = (field) => {
  return map(o => ({ key: o.key, label: getOptionLabel(o.valueTranslatable) }), pathOr([], ["selOptions"], field));
}

const getOptionLabel = (localizableString) => {
  const navLocale = split("-", getNavLocale())[0];
  let objValue = filter(
    (obj) => startsWith(navLocale, obj.key),
    localizableString.value
  );

  if (isEmpty(objValue)) {
    const defaultLocale = localizableString.defaultLocale;
    objValue = filter(
      (obj) => obj.key === defaultLocale,
      localizableString.value
    );
  }

  if (isEmpty(objValue)) {
    return "";
  }

  return objValue[0].value;
};